import { FlexRow } from '@/components/common/Flex';
import { FlexProps, Skeleton, Tooltip } from '@chakra-ui/react';

interface CarouselPillLayoutProps extends FlexProps {
    isReadOnly?: boolean;
    innerProps?: FlexProps;
    isLoading?: boolean;
    tooltip?: string;
}

const CarouselPill = ({
    isReadOnly,
    onClick,
    children,
    isLoading,
    tooltip,
    ...props
}: CarouselPillLayoutProps) => {
    const sharedProps = { rounded: 8, h: 12, w: 40, minW: 40 };

    if (isLoading) {
        return <Skeleton {...sharedProps} {...props} />;
    }

    const inner = (
        <FlexRow
            {...sharedProps}
            bg="white"
            px={3}
            py={2}
            borderColor="border"
            borderWidth={1}
            transition="all 200ms"
            _hover={
                !isReadOnly
                    ? {
                          cursor: 'pointer',
                          shadow: 'sm',
                          transition: 'all 200ms',
                          transform: 'translateY(-10%)',
                      }
                    : undefined
            }
            onClick={(e) => {
                if (isReadOnly) return;
                onClick?.(e);
            }}
            {...props}
        >
            {children}
        </FlexRow>
    );

    return tooltip ? (
        <Tooltip
            label={tooltip}
            aria-label={tooltip}
            placement="top"
            gutter={12}
        >
            {inner}
        </Tooltip>
    ) : (
        inner
    );
};
export default CarouselPill;
